import React from 'react';
import { NumberInput, Tooltip } from 'components/common';

const NumberFormField = ({ config, value, setValue, register, errors, readOnly, disabled, setFetchInProgress, integerOnly }) => {

  const onChange = (e) => {
    setValue(config.name, e.target.value);
    if(config.publish_on_change_key != undefined) {
      var event = new CustomEvent(config.publish_on_change_key, { "detail": e.target.value });
      document.dispatchEvent(event);
    }
  }

  return (
    <tr>
      <td>
        {t(config.label)} { config.tooltip_text != undefined && <Tooltip title={t(config.tooltip_text)} /> }
        {config.helper_text != undefined && (
          <><br /><small className="form-text text-muted" dangerouslySetInnerHTML={{ __html: t(config.helper_text) }} /></>
        )}
      </td>
      <td align="right">
        <NumberInput
          name={config.name}
          placeholder={config.placeholder}
          register={register}
          errors={errors}
          class_name={config.class_name}
          integerOnly={integerOnly}
          validators={config.validators != undefined ? config.validators : []}
          value={value}
          readOnly={readOnly}
          onChange={onChange}
        />
      </td>
    </tr>
  )
}
export default NumberFormField;